import { requestToKemsuWebSystem } from "~/shared/api/kemsuweb"
import { ignoreKemsuWebSystem } from "~/shared/config"
import { isStandalone } from "~/shared/lib/utils"

/**
 * Проверка валидности сессии системы на KemsuWeb
 * @return если сессия валидна, вернет true
 */
export async function checkKemsuWebSystemSessionValidity(): Promise<boolean> {
	if (ignoreKemsuWebSystem || isStandalone()) return true

	const userId = await requestToKemsuWebSystem("get-user-id")
	return userId ? userId != -1 : false
}
